module["exports"] = [
  "#####",
  "#####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/postcode.js
// module id = 850
// module chunks = 1